import { Service } from './service.service';
import { Projeto } from './../model/projeto';
import { Injectable } from '@angular/core';

@Injectable()
export class ProjetoService extends Service<Projeto> {

  protected getTable() {
    return 'projeto';
  }

  ultimas() {
    return super.ultimas(6);
  }

  protected getPageMax() {
    return 10;
  }

getConfig() {
  const configUrl = './../../assets/projetos.json';
  return this.http.get(configUrl);
}

  importar() {
    this.getConfig()
    .subscribe((data: Projeto[]) => {
       data.forEach(element => {
         this.salvar(element);
       });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/service/projeto.service.ts